/* eslint-disable no-param-reassign */
import { Injectable, inject } from '@angular/core';

import { PrettyUrlsConfig } from '@frontend/sports/common/client-config-data-access';
import { SegmentNormalizer } from '@frontend/sports/navigation/core/feature/url-builder';
import { produce } from 'immer';
import { clone } from 'lodash-es';

import { FavouriteType, FavouritesDto, FavouritesViewModel } from './favourites.model';

@Injectable({ providedIn: 'root' })
export class FavouritesModelFactory {
    private normalizer: SegmentNormalizer;

    constructor() {
        const urlConfig = inject(PrettyUrlsConfig);

        this.normalizer = new SegmentNormalizer(urlConfig);
    }

    toModel(dto: FavouritesDto | FavouritesViewModel): Readonly<FavouritesViewModel> {
        return produce<FavouritesViewModel>(dto as FavouritesViewModel, (draft) => {
            draft.id = this.getToken(draft.type, draft.name || '', draft.sport.id, draft.itemId || 0);
            draft.key = this.getKey(draft);
            draft.count = 0;
            draft.region = clone(dto.region);
            draft.sport.name = dto.sport.name;
            draft.imageProfile = dto.imageProfile;
            draft.participantImage = dto.participantImage;
        });
    }

    toDto(val: FavouritesViewModel): Readonly<FavouritesDto> {
        return val as FavouritesDto;
    }

    private getKey(value: FavouritesDto | FavouritesViewModel): string {
        return [value.type, 0, value.sport.id, value.itemId, value.name].filter((value) => value !== undefined && value !== '').join(',');
    }

    private getToken(type: FavouriteType, name: string, sport: number, item: number | string): string {
        return this.normalizer.normalize(`${type} ${name} ${sport || 0} ${item || ''}`);
    }
}
